import React, { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  ThemeProvider,
  Link as MuiLink,
} from '@mui/material';
import axios from 'axios';
import { Link, Link as RouterLink } from 'react-router-dom';
import getTheme from '../theme/theme';
import { toast } from 'react-toastify';
import { AUTOFILL_STYLES, BASEURL } from "../constants/Common"

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [resetSuccess, setResetSuccess] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const theme = getTheme();

  const handleResetPassword = async () => {
    setIsButtonVisible(false); // Hide the button when clicked

    if (email.trim().length === 0) {
      toast.error('Please enter your email.');
      setIsButtonVisible(true);
      return;
    }

    try {
      const response = await axios.post(
        BASEURL + '/password-reset/',
        { email }
      );
      if (response.status === 200) {
        setResetSuccess(true);
        toast.success('Password reset link has been sent to your email.');
      }
    } catch (error) {
      // Handle the error appropriately
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        toast.error('No user found with this email id.');
      } else {
        console.error('An error occurred. Please try again later.');
      }
      setIsButtonVisible(true); // Show button again if there's an error
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    handleResetPassword();
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Container component='main' maxWidth='xs'>
        {resetSuccess ? (
          <Box
            sx={{
              marginTop: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <Typography variant='body1'>
              An email with a link to reset your password has been sent. Please access this email and reset your password.
            </Typography>



          </Box>
        ) : (
          <Box
            sx={{
              marginTop: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography component='h1' variant='h5'>
              Reset Password
            </Typography>
            <Box component='form' noValidate sx={{ mt: 1 }} onSubmit={handleSubmit}>
              <TextField
                margin='normal'
                required
                fullWidth
                id='email'
                label='Email Address'
                name='email'
                autoComplete='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ marginBottom: 4, ...AUTOFILL_STYLES(theme) }}
              />
              <Button
                type='button'
                fullWidth
                variant='contained'
                onClick={handleResetPassword}
                sx={{ mt: 1, mb: 2, '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
                disabled={!isButtonVisible}
              >
                Reset Password
              </Button>
            </Box>
            {/* <MuiLink
            component={RouterLink}
            to='/login'
            variant='body2'
            sx={{ color: 'red' }}
          >
            Remember password? Login
          </MuiLink> */}

            {/* <ButtonBase
          component={RouterLink}
          to='/login'
          sx={{
           
            padding: '6px', // Increase padding to increase clickable area
          }}
        >
          Remember password? Login
        </ButtonBase> */}
            <RouterLink
              to='/login'
              style={{
                padding: '12px 6px', // Increase padding to create a larger clickable area
                color: 'inherit',
                cursor: 'pointer',
                display: 'inline-block', // Ensure link behaves like a block element

              }}
            >
              Remember password? Login
            </RouterLink>
          </Box>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default ResetPassword;
